import axios from "axios";
import Cookies from 'js-cookie';

const token = Cookies.get('token');
const useraccessToken = Cookies.get('Useraccesstoken');

let axiosInstance = null;
const CreateAxiosInstance =(useraccessToken) =>{ 
    console.log("creating instance")
    axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_WORKFLOW_API_PATH + "wfapi/",
    //  baseURL: "http://localhost:3000/wfapi/",
     headers: { 'Authorization': 'Bearer ' + useraccessToken }

});};

CreateAxiosInstance(Cookies.get('Useraccesstoken'));

export const getAxiosInstance = () =>{
    return axiosInstance;
}

export const updateAxioswithcookie = (useraccessToken) =>{
    if(useraccessToken){
        console.log("test")
        CreateAxiosInstance(useraccessToken);
    }
};

//export default axiosInstance

// setting when env files are enabled in root directory . Please uncomment the below code and comment above one
//while using env file to set the urls.

// const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
// const axiosInstance = axios.create({
//   baseURL:`${API_ENDPOINT}`
// })